import PropTypes from 'prop-types';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import styles from './styles.module.css';

const DEFAULT_COLORS = ['#10B2D0', '#095664', '#98D0DA'];

const PieChartCard = ({
  title,
  data,
  colorArray: customColorArray,
  arcLabelMode = 'value',
  showLegend = true,
}) => {
  const safeData = Array.isArray(data) ? data : [];
  const colorArray =
    customColorArray && customColorArray.length > 0
      ? customColorArray
      : DEFAULT_COLORS;

  const total = safeData.reduce((sum, item) => sum + (Number(item.value) || 0), 0);
  const pieData = [];
  for (let i = 0; i < safeData.length; i++) {
    pieData.push({
      ...safeData[i],
      color: colorArray[i % colorArray.length],
    });
  }

  const getArcLabel = (item) => {
    if (arcLabelMode === 'percent') {
      if (!total) return '0%';
      return `${Math.round((item.value / total) * 100)}%`;
    }
    return `${item.value}`;
  };

  const hasData = safeData.length > 0 && total > 0;

  return (
    <div className={styles.cardLargeBody}>
      {title ? <h2 className={styles.title}>{title}</h2> : null}
      <div className={styles.pieCardContent}>
        <div className={styles.pieCardChart}>
          {!hasData ? (
            <div className={styles.pieCardEmpty}>No data to display</div>
          ) : (
          <PieChart
            margin={10}
            hideLegend
            width={320}
            height={260}
            slotProps={{
              legend: { hidden: true },
            }}
            series={[
              {
                highlightScope: { faded: 'series', highlighted: 'item' },
                faded: { innerRadius: 60, additionalRadius: -2 },
                arcLabel: getArcLabel,
                arcLabelMinAngle: 30,
                data: pieData,
                innerRadius: 70,
                outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                startAngle: -180,
                endAngle: 180,
                cx: 150,
                cy: 130,
              },
            ]}
            sx={{
              [`& .${pieArcLabelClasses.root}`]: {
                fill: 'white',
                fontWeight: 'bold',
              },
              '& .MuiPieArc-root': {
                stroke: 'var(--white)',
                strokeWidth: 2,
              },
            }}
            aria-label={title}
          />
          )}
        </div>

        {showLegend && hasData ? (
          <div className={styles.pieCardLegend}>
            {pieData.map((item) => (
              <div key={item.id ?? item.label} className={styles.pieCardLegendItem}>
                <div
                  className={styles.pieCardLegendDot}
                  style={{ backgroundColor: item.color }}
                />
                <div className={styles.pieCardLegendText}>{item.label}</div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

PieChartCard.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ),
  colorArray: PropTypes.arrayOf(PropTypes.string),
  arcLabelMode: PropTypes.oneOf(['value', 'percent']),
  showLegend: PropTypes.bool,
};

PieChartCard.defaultProps = {
  data: [],
};

export default PieChartCard;
